import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "./GamePeriod.css";

export default function GameModify(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    appBar: {
      position: "relative",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "75%",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));

  let curr = new Date();
  let week = [];

  for (let i = 1; i <= 7; i++) {
    let first = curr.getDate() - curr.getDay() + i;
    let day = new Date(curr.setDate(first)).toISOString().slice(0, 10);
    week.push(day);
  }

  const classes = useStyles();

  const [open, setOpen] = React.useState(true);
  const [loading, setLoading] = React.useState(true);
  const [periods, setPeriods] = React.useState([]);
  const [periodsSelected, setPeriodsSelected] = React.useState([]);
  const [startDate, setStartDate] = React.useState(week[0]);
  const [endDate, setEndDate] = React.useState(week[6]);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [filterChanged, setFilterChanged] = React.useState(false);

  useEffect(() => {
    PeriodsValues();
  }, []);

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
    setOpen(false);
  };
  const handleShow = () => {
    PeriodsInsert();
  };

  const selectRowProp = {
    mode: "checkbox",
    clickToSelect: true,
    onSelect: onRowSelect,
    onSelectAll: onSelectAll,
  };

  function onSelectAll(isSelected, rows) {
    if (isSelected) {
      rows.forEach((row) => {
        addIdPeriodsSelected(row.numberOfPeriod);
        //setPeriodsSelected(periodsSelected.concat(row.numberOfPeriod));
      });
    } else {
      setPeriodsSelected([]);
    }
  }

  function onRowSelect(row, isSelected, e) {
    if (isSelected) {
      setPeriodsSelected(periodsSelected.concat(row.numberOfPeriod));
    } else {
      setPeriodsSelected(
        periodsSelected.filter(
          (item) => item.numberOfPeriod !== row.numberOfPeriod
        )
      );
    }
  }

  const addIdPeriodsSelected = (id) => {
    setPeriodsSelected((prevPeriodsSelected) => [...prevPeriodsSelected, id]);
  };

  const PeriodsValues = () => {
    //Profile Props',props )
    const url =
      process.env.REACT_APP_API2_URL +
      "/Game/Period_GetList?idSport=" +
      props.IdSport;
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setPeriods(data.filter((x) => x.numberOfPeriod != 0));
      });
    setLoading(false);
  };

  const PeriodsInsert = async () => {
    let responseData = 0;
    for (let i = 0; i < props.IdGames.length; i++) {
      let periods = {
        periodsSelected,
      };
      console.log("periods =====>", periodsSelected);
      await axios({
        method: "post",
        url:
          process.env.REACT_APP_API2_URL +
          "/Game/GamePeriodsInsert?IdGame=" +
          props.IdGames[i],
        //url:'https://localhost:44337/api/Game/GamePeriodsInsert?IdGame=' + props.IdGames[i],
        /*  REPLACE WITH SELECT DATA */
        data: periods,
      }).then((response) => {
        if (response.data === 1) {
          responseData = response.data;
        }
      });
    }
    if (responseData === 1) {
      props.clearArray();
      props.searchGameValues();
      handleClose();
    }
  };

  const options = {
    beforeShowError: (type, msg) => {
      this.setState({ errType: type, errMsg: msg });
      // return false or do not return will not trigger the toastr,
      // if you want the toastr popup, you should return true always.
    },
  };

  const printList = () => {
    return (
      <React.Fragment>
        <Dialog style={{ maxWidth: "75%" }} open={open} onClose={handleClose}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                Periods
              </Typography>
            </Toolbar>
          </AppBar>
          {loading ? (
            <CircularProgress style={{ margin: "0 auto" }} />
          ) : (
            <React.Fragment>
              <br />
              {periods && (
                <div>
                  <BootstrapTable
                    data={periods}
                    selectRow={selectRowProp}
                    options={options}
                  >
                    <TableHeaderColumn
                      visible="none"
                      isKey={true}
                      hidden
                      dataField="numberOfPeriod"
                    >
                      numberOfPeriod
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      filter={{ type: "TextFilter", delay: 1000 }}
                      dataField="periodDescription"
                    >
                      Period
                    </TableHeaderColumn>
                  </BootstrapTable>
                </div>
              )}
            </React.Fragment>
          )}
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={handleShow}
            >
              Create Periods
            </Button>
            <Button
              color="inherit"
              startIcon={<CancelIcon />}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  };

  return printList();
}
